import { z } from "zod";
export const ReimprimirJobSchema = z.object({
    jobId: z.string().uuid("ID de trabajo de impresión inválido"),
});
/**
 * Ticket listo para imprimirse desde el navegador (impresoras "SISTEMA_LOCAL":
 * USB/driver de Windows, sin IP de red — el backend no puede hablarles por
 * TCP, así que le pasa los datos ya armados al frontend, que dispara
 * window.print() con apps/web/src/lib/impresionWindows.ts).
 */
export const ItemTicketClienteSchema = z.object({
    cantidad: z.number().int().positive(),
    nombre: z.string(),
    precio: z.number().optional(),
    notas: z.string().nullable().optional(),
});
/** Representación gráfica DIAN: presente cuando la venta ya tiene CUFE/CUDE. */
export const DatosDianTicketClienteSchema = z.object({
    tipoDocumento: z.enum(["POS", "FACTURA"]),
    numero: z.string(),
    cufe: z.string(),
    qrUrl: z.string().nullable().optional(),
    emisorNit: z.string().nullable().optional(),
    emisorRazonSocial: z.string().nullable().optional(),
    responsableIva: z.boolean().nullable().optional(),
    resolucionNumero: z.string().nullable().optional(),
    resolucionPrefijo: z.string().nullable().optional(),
    rangoDesde: z.number().nullable().optional(),
    rangoHasta: z.number().nullable().optional(),
    resolucionVigencia: z.string().nullable().optional(),
    ambientePruebas: z.boolean().optional(),
    softwareNombre: z.string().nullable().optional(),
});
export const DatosTicketClienteSchema = z.object({
    dian: DatosDianTicketClienteSchema.nullable().optional(),
    titulo: z.string(),
    subtitulo: z.string().optional(),
    mesaNumero: z.union([z.number(), z.string()]).optional(),
    meseraNombre: z.string().optional(),
    fecha: z.string().optional(),
    items: z.array(ItemTicketClienteSchema),
    subtotal: z.number().optional(),
    descuento: z.number().optional(),
    propina: z.number().optional(),
    total: z.number().optional(),
    pagos: z.array(z.object({ medioPago: z.string(), monto: z.number() })).optional(),
    clienteNombre: z.string().nullable().optional(),
    clienteDocumento: z.string().nullable().optional(),
    notasGenerales: z.string().nullable().optional(),
    logoUrl: z.string().nullable().optional(),
    imprimirLogoTicket: z.boolean().optional(),
    encabezadoTicket: z.string().nullable().optional(),
    pieTicket: z.string().nullable().optional(),
    sucursalNombre: z.string().nullable().optional(),
});
/** Trabajo de comanda pendiente de imprimirse desde el navegador (ver arriba). */
export const PrintJobLocalPendienteSchema = z.object({
    id: z.string().uuid(),
    impresoraNombre: z.string(),
    creadoEn: z.string(),
    ticket: DatosTicketClienteSchema,
});
/**
 * Trabajo pendiente de imprimirse recogido por el puente de impresión que
 * corre en la LAN del local — no por el navegador. Ya trae el contenido en
 * bytes ESC/POS listos para reenviar tal cual. Según `tipoConexion`, el
 * puente lo manda distinto: "RED_IP" por TCP a `ip:puerto`; "USB_PUENTE" lo
 * copia al recurso compartido de Windows nombrado en `ip` (ver
 * puente-impresion/puente.js).
 */
export const PrintJobRedPendienteSchema = z.object({
    id: z.string().uuid(),
    impresoraNombre: z.string(),
    tipoConexion: z.string(),
    ip: z.string(),
    puerto: z.number().int(),
    contenido: z.string(),
    creadoEn: z.string(),
});
export const ImprimirRespuestaSchema = z.object({
    exito: z.boolean(),
    mensaje: z.string(),
    // Presente solo cuando la impresora de destino es SISTEMA_LOCAL: el
    // frontend debe imprimir esto mismo con window.print() en vez de esperar
    // que el backend lo haya enviado por TCP.
    ticketCliente: DatosTicketClienteSchema.optional(),
});
//# sourceMappingURL=impresion.schema.js.map